
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 8 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.703 17.297V2.407l2.455 2.466a.703.703 0 10.997-.992L4.498.207a.704.704 0 00-.996 0L-.155 3.88a.703.703 0 00.997.992l2.455-2.467v14.89a.703.703 0 001.406 0z"}})])
          )
        }
      }
    